import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Phone"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5003 21.75H19.3728C4.63531 20.9025 2.54281 8.4675 2.25031 4.6725C2.20271 4.07657 2.39423 3.48619 2.7826 3.03169C3.17097 2.57719 3.72425 2.29593 4.32031 2.25H8.45281C9.06752 2.24941 9.62037 2.62392 9.84781 3.195L10.9878 6C11.2122 6.55736 11.0823 7.19482 10.6578 7.62L9.06031 9.2325C9.57146 12.1372 11.842 14.4137 14.7453 14.9325L16.3728 13.32C16.8044 12.9001 17.4453 12.779 18.0003 13.0125L20.8278 14.145C21.3901 14.3795 21.7546 14.9308 21.7503 15.54V19.5C21.7503 20.7426 20.743 21.75 19.5003 21.75ZM4.50025 3.75C4.08604 3.75 3.75025 4.08579 3.75025 4.5V4.56C4.09525 9 6.30775 19.5 19.4553 20.25C19.6543 20.2623 19.85 20.1949 19.9991 20.0626C20.1483 19.9303 20.2387 19.744 20.2503 19.545V15.54L17.4228 14.4075L15.2703 16.545L14.9103 16.5C8.38525 15.6825 7.50025 9.1575 7.50025 9.09L7.45525 8.73L9.58525 6.5775L8.46025 3.75H4.50025Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Phone.vue"]]);
